import { ElMessage } from "element-plus";
import { Http } from "../../plugins/http";

const ALD_TOKEN_KEY = "ald-token";

export const baseUrl = "https://api.mazhou.cc";

export const http = new Http({
  baseUrl,
  setHeaders: () => {
    const token = localStorage.getItem(ALD_TOKEN_KEY);
    return {
      Authorization: token ? `Bearer ${token}` : "",
    };
  },
  fail: (err: any) => {
    const message = err?.response?.data?.message || err?.message;
    if (message) {
      ElMessage.warning(message);
    }
  },
});

export const setQrcodeConfig = async (params: any) => {
  try {
    await http.post("/admin/workbench-set-qrcode", params);
    return true;
  } catch {
    return false;
  }
};

export const qrcodeRename = async (params: any) => {
  try {
    await http.post("/admin/workbench-rename", params);
    return true;
  } catch {
    return false;
  }
};
